import React from 'react';
import { Box, Typography, Divider, useTheme, Alert } from '@mui/material';
import AssetSummarySection from './AssetSummarySection';
import DefectSummarySection from './DefectSummarySection';
import PotholeHeatmapSection from './PotholeHeatmapSection';
import { useAuth } from '../../context/AuthContext';
import DisciplineAccessControl from '../common/DisciplineAccessControl';

const RoadDashboard = () => {
  // 🔐 GET USER CONTEXT FOR PERMISSION FILTERING
  const { user, getUserOrganization } = useAuth();
  const theme = useTheme();
 
  // Get organization info from auth context
  const userOrganization = getUserOrganization();
  const organizationName = userOrganization?.name || '';

  return (
    <DisciplineAccessControl requiredDiscipline="Road Pavement">
    <Box sx={{ maxWidth: '100%' }}>
      {/* Asset Summary Section - HIDDEN */}
      {/* <Typography
        variant="h5"
        gutterBottom
        sx={{
          mb: 3,
          mt: 3,
          fontWeight: 600,
          fontSize: { xs: '1.25rem', md: '1.5rem' }
        }}
      >
        Asset Summary
      </Typography>

      <Box sx={{ py: 1, width: '100%' }}>
        <AssetSummarySection />
      </Box>

      <Divider sx={{ my: 5 }} /> */}

      {/* Defect Summary Section */}
      <Typography 
        variant="h5" 
        sx={{ 
          mb: 2,
          fontWeight: 600,
          fontSize: { xs: '1.25rem', md: '1.5rem' }
        }}
      >
        Defect Summary
      </Typography>

      <DefectSummarySection user={user} />

      {/* Activity Patterns Section */}
      <Typography 
        variant="h5" 
        sx={{ 
          mb: 2,
          mt: 4,
          fontWeight: 600,
          fontSize: { xs: '1.25rem', md: '1.5rem' }
        }}
      >
        Activity Patterns
      </Typography>

      <Box sx={{ 
        display: 'grid', 
        gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, 
        gap: 3,
        mb: 3
      }}>
        <PotholeHeatmapSection user={user} />
        
        {/* Empty second card placeholder */}
        <Box
          sx={{
            p: 3,
            borderRadius: 2,
            boxShadow: '0 6px 20px rgba(0, 0, 0, 0.05)',
            border: '2px dashed',
            borderColor: 'divider',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '400px',
            backgroundColor: 'background.paper'
          }}
        >
          <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center' }}>
            Coming Soon
            <br />
            <Typography variant="caption" color="text.secondary">
              Additional analytics will be displayed here
            </Typography>
          </Typography>
        </Box>
      </Box>

      {/* Add more sections here later */}
    </Box>
    </DisciplineAccessControl>
  );
};

export default RoadDashboard;